import React from "react";
import { Modal } from "antd";
import { Addon, MoneyFormatter } from "./types";

// Explains the "Pay Remaining Balance" figure: the balance without add-ons,
// each unpaid add-on, and the two together.
export default function PriceBreakdownModal(
  props: {
    open: boolean;
    onClose: () => void;
    money: MoneyFormatter;
    addons: Addon[];
    balanceExAddons: number;
    currBalanceExAddons: number;
    balanceAmount: number;
    currBalanceAmount: number;
  }
) {
  const { open, onClose, money, addons, balanceExAddons, currBalanceExAddons, balanceAmount, currBalanceAmount } = props;

  return (
    <Modal title="Price Breakdown" open={open} onCancel={onClose} footer={null} width={420}>
      <div className="price-breakdown">
        <div className="price-breakdown_row">
          <span>Remaining Balance</span>
          <span>{money(balanceExAddons, currBalanceExAddons)}</span>
        </div>
        {addons.map((addon) => (
          <div key={addon.id} className="price-breakdown_row">
            <span>{addon.remark}</span>
            <span>{money(addon.amount, addon.currency_amount)}</span>
          </div>
        ))}
        <div className="price-breakdown_row price-breakdown_row-total">
          <span>Grand Total</span>
          <span>{money(balanceAmount, currBalanceAmount)}</span>
        </div>
      </div>
    </Modal>
  );
}
